<template>
  <div class="nav-bar">
    <div class="nav-bar-left">
      <div v-if="!$slots.left" class="back-icon" @click="handleBack">
        <base-icon name="back_dark" />
      </div>
      <template v-else>
        <slot name="left" />
      </template>
    </div>
    <div class="nav-bar-title">
      <slot />
    </div>
    <div class="nav-bar-right">
      <slot name="right" />
    </div>
  </div>
</template>

<script>
import { routerStack } from '@/main';

export default {
  name: 'AppHeader',
  props: {
    // header 的高
    value: Number,
    // 后退hook
    // 若return false时阻止路由后退
    backHook: {
      type: Function,
      default: () => {
        return true;
      },
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.$emit('input', this.$el.offsetHeight);
    });
  },
  methods: {
    handleBack() {
      // 判断是否需要阻止逻辑继续
      if (this.backHook && typeof this.backHook === 'function') {
        if (this.backHook() === false) return false;
      }
      if (routerStack.length === 1) {
        this.$router.replace('/')
      } else {
        if (window.history.length > 1) {
          this.$router.back();
        }
      }

    },
  },
};
</script>

<style lang="less">
.nav-bar {
  position: relative;
  height: 88px;
  background-color: #fff;
  display: flex;
  align-items: center;
  border-bottom: 1px solid #f1f2f6da;

  .nav-bar-left,
  .nav-bar-right {
    position: absolute;
    top: 0;
    bottom: 0;
    display: flex;
    align-items: center;
    padding: 0 32px;
  }

  .nav-bar-left {
    left: 0;

    .back-icon {
      width: 36px;
      height: 36px;
    }
  }

  .nav-bar-right {
    right: 0;
  }

  .nav-bar-title {
    max-width: 60%;
    margin: 0 auto;
    color: #333;
    font-weight: 500;
    font-size: 36px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
}
</style>
